import { getOnpremHostname } from 'omni-package-react-core';
import { getIdpTenantUrl } from './getIdpTenantUrl';

export default function closeCurrentSession(): void {
  sessionStorage.clear();
  const url = `${getIdpTenantUrl()}login/signout?fromURI=${getOnpremHostname()}/EEMWPNP1/logoffonpremise`;
  window.location.replace(url);
}
